/**
 *  Bootloader triggered at application startup
 *
 *  - Automatically validating environment variables
 */
/// @XXX "nuxt4" preventing `useRuntimeConfig()` outside of Nuxt Context
/// @XXX "nuxt4" clearing `process.env`
///    ↳ --patch surgery--: using "vite" builder to define `process.env`
///      in "nuxt.config.ts" [1] → not working for production build
///    ↳ --smelly patch surgery--: setting `NodeJS.Process` manually [2]
///    ↳ workaround: using "vite" `ImportMetaEnv` feature → explaining why
///      ".env" files contain `VITE__` prefix
/// @link https://github.com/nuxt/nuxt/discussions/15931
/// @link @link https://stackoverflow.com/a/74170733/6003907 [1]
/// @link https://github.com/nuxt/nuxt/discussions/15931#discussioncomment-1696476 [2]
/// @link https://vite.dev/guide/env-and-mode.html [3]
import { pipe, isEmpty, any, view, lensProp } from '~/utils/lib/core/prelude'
import Console from '~/utils/lib/core/console'

const console = new Console('plugin:bootloader')

export const ERRORS = {
  UNSET_VARIABLES: 'some env variables are either missing or unset'
}

// (cf "nuxt.config.ts" runtimeConfig)
const AVAILABLE_ENVIRONMENT_VARIABLES = [
  'VITE_ENVIRONMENT',
  'VITE_FRONTEND_CLIENT_PROTOCOL',
  'VITE_FRONTEND_CLIENT_DOMAIN',
  'VITE_FRONTEND_CLIENT_PATH',
  'VITE_ACCOUNT_API_URL',
  'VITE_BASE_API_URL',
  'VITE_CLIENT_API_URL',
  'VITE_HAMAC_API_URL',
  'VITE_TRANSAT_API_URL',
  'VITE_PREPA_PAIE_API_URL',
  'VITE_EXPORTS_API_URL',
  'VITE_BUZZ_WS_DOMAIN_URL',
  'VITE_BUZZ_WS_PATH_URL',
  'VITE_CSS_API_URL',
]

export default defineNuxtPlugin(nuxtApp => {
  console.log(
    'extracting environment variables',
    import.meta.env,
    nuxtApp.$config.public
  )

  validateEnvironmentVariables(import.meta.env)
})
/**
 *  Validate Environment Variables
 *  @param {ImportMetaEnv} env
 *  @throws {Error}
 */
function validateEnvironmentVariables(env) {
  const hasUnsetVariables = any(
    pipe(
      key => view( lensProp(key), env),
      isEmpty
    )
  )(AVAILABLE_ENVIRONMENT_VARIABLES)

  if (hasUnsetVariables)
    throw new Error(ERRORS.UNSET_VARIABLES)
}
